import React, { useEffect } from "react";
// import avatar from "../assets/images/avatar.png";
import { useAuth } from "../context/authContext";
import { getUsuario } from "../services/api";
import { getUser } from "../utils";
import { useHistory } from "react-router";
import { Card } from "reactstrap";

const InfoSocio = () => {
  const user = getUser();
  const { LogOut } = useAuth();
  const history = useHistory()

  // const validateEmail = async () => {
  //   const user_web = await getUsuario(user.numero_documento);
    
  //   if(user_web?.email === null ){
  //     console.log('email es nulo')
  //     history.push('/solicitarmail')
  //   }else{
  //     console.log('email NO es nulo: ' + user_web.email)
  //   }
  // }

  useEffect(() => {
    const validateEmail = async () => {
      const user_web = await getUsuario(user.numero_documento);
      if(user_web?.email === null ){
        console.log('email es nulo')
        history.push('/solicitarmail')
      }else{
        console.log('email NO es nulo: ' + user_web.email)
      }
    }
    validateEmail()
  }, [user, history])

 

  return (
    <Card className="p-4 text-center mt-4">
      <div className="mt-2">
        <div align="right" className="mr-3">
          <button
            style={{
              borderRadius: "50%",
              width: 30,
              height: 30,
            }}
            onClick={() => LogOut()}
          >
            x
          </button>
        </div>
        <div className="mt-4" align="center" style={{ lineHeight: 0.9 }}>
          {/* <img src={avatar} alt="" className="w-25 mb-2" /> */}
          <h4 className="my-3">{user.apellido_nombres}</h4>
          <p>
            Socio ID: <b>{user.numero_socio}</b>
          </p>
          <p>
            DNI: <b>{user.numero_documento}</b>
          </p>
          <p>
            ORDEN: <b>{user.orden}</b>
          </p>
          <h5 className="mt-5">¡IMPORTANTE!</h5>
          <p>
            *El uso de esta credencial debe ser acompañado por el DNI del
            titular
          </p>
        </div>
      </div>
    </Card>
  );
}

export default InfoSocio;
